import { Provider } from "react-redux";
import React from "react";
import store from "../../stores/reduxStore";

import Collection_List from "./collectionlist";

export default class Collection_List_Parent extends React.Component {
    render() {
        // this component exists to pass the redux store to the legacy iconlist component
        return (
            <Provider store={store}>
                <Collection_List args={this.props.args} />
            </Provider>
        );
    }
}
